export const setLoading = ({ commit }, obj) => {
  commit("setLoading", obj);
};

export const setMessages = ({ commit }, obj) => {
  commit("setMessages", obj);
};

export const clearMessages = ({ commit }) => {
  commit("clearMessages");
};

/**
 * Busca o saldo de cashback do consumidor.
 * @param {object} context
 * @param {object} http instância axios injetada pelo componente
 * @return {Promise<void>}
 */
export const fetchBalance = async ({ commit }, { http }) => {
  try {
    const response = await http.get("/cashback/balance");
    commit("setBalance", response.data);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("[Cashback] fetchBalance error:", error);
    }

    commit("setMessages", {
      variant: "danger",
      text: "Não foi possível carregar seu saldo de cashback.",
    });
  }
};

/**
 * Busca a primeira página de transações de cashback.
 * @param {object} context
 * @param {object} http instância axios injetada pelo componente
 * @return {Promise<void>}
 */
export const fetchTransactions = async ({ commit }, { http }) => {
  try {
    const response = await http.get("/cashback/transactions?limit=15");
    commit("setTransactions", response.data.data);
    commit("setNextCursor", response.data.next_cursor);
    commit("setHasMore", response.data.has_more);

    if (response.data.total_count !== undefined) {
      commit("setTotalCount", { totalCount: response.data.total_count });
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("[Cashback] fetchTransactions error:", error);
    }

    commit("setMessages", {
      variant: "danger",
      text: "Não foi possível carregar o histórico de cashback.",
    });
  }
};

/**
 * Carrega mais transações usando cursor de paginação.
 * @param {object} context
 * @param {object} payload contém http e cursor
 * @return {Promise<void>}
 */
export const fetchMoreTransactions = async ({ commit, state }, { http }) => {
  const cursor = state.cashback.nextCursor;

  if (!cursor) {
    return;
  }

  commit("setLoadingMore", { loadingMore: true });

  try {
    const response = await http.get(
      `/cashback/transactions?cursor=${cursor}&limit=15`
    );
    commit("appendTransactions", response.data.data);
    commit("setNextCursor", response.data.next_cursor);
    commit("setHasMore", response.data.has_more);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("[Cashback] fetchMoreTransactions error:", error);
    }

    commit("setMessages", {
      variant: "danger",
      text: "Não foi possível carregar mais transações.",
    });
  }

  commit("setLoadingMore", { loadingMore: false });
};
